import React from 'react';

import { Center, useBreakpointValue } from '@chakra-ui/react';

import { RepublicCompactLogoIcon } from '../icons/brand-logos/republic-compact-logo-icon';
import type { AvatarProps } from './avatar';

interface AvatarAdminBadgeProps {
  size: AvatarProps['size'];
}

interface AvatarAdminBadgeTheme {
  size: number;
  iconSize: number;
  offset: number;
  borderRadius: number;
}

const theme: Record<string, AvatarAdminBadgeTheme> = {
  xs: {
    size: 10,
    iconSize: 6,
    offset: 2,
    borderRadius: 1,
  },
  sm: {
    size: 15,
    iconSize: 9,
    offset: 3,
    borderRadius: 2,
  },
  md: {
    size: 25,
    iconSize: 12,
    offset: 5,
    borderRadius: 4,
  },
  lg: {
    size: 25,
    iconSize: 12,
    offset: 5,
    borderRadius: 4,
  },
  xl: {
    size: 45,
    iconSize: 25,
    offset: 9,
    borderRadius: 6,
  },
};

const defaultTheme = theme.md;

export const AvatarAdminBadge = ({
  size: responsiveSize,
}: AvatarAdminBadgeProps) => {
  const themeSize =
    typeof responsiveSize === 'string'
      ? responsiveSize
      : // TODO: Fix this eslint error
        // eslint-disable-next-line react-hooks/rules-of-hooks
        useBreakpointValue(responsiveSize ?? ['md'], { fallback: 'md' });

  const { size, iconSize, offset, borderRadius } =
    themeSize && theme[themeSize] ? theme[themeSize] : defaultTheme;

  return (
    <Center
      bg="grey.50"
      w={`${size}px`}
      h={`${size}px`}
      pos="absolute"
      borderRadius={`${borderRadius}px`}
      bottom={`-${offset}px`}
      right={`-${offset}px`}
    >
      <RepublicCompactLogoIcon w={`${iconSize}px`} h={`${iconSize}px`} />
    </Center>
  );
};
